<template>
    <div data-cy="container_button_secondary">
        <div :id="btnId"
                class="w-100 border border-blue-300"
                :class="{'opacity-30': isBtnDisable}">
                <div class="py-1.5 text-blue-300 text-2xl text-center"
                    v-html="btnMsg"
                    @click="clickButton()"
                    data-cy="btn_button_secondary"></div>
            </div>
    </div>
</template>
<script>
export default {
    name: 'SecondaryButton',
    props: {
        btnId: String,
        btnMsg: String,
        isBtnDisable: Boolean
    },
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('onClick');
        }
    }
}
</script>